export enum ExportOptions {
  FullReport = 'full_report',
  BasicReport = 'basic_report',
}
